import React from "react"

// Cintillo de ofertas (rotativo)
import OfferTicker from "../components/Offers/OfferTicker"

// Contenido principal ya existente
import HeroSlider from "../components/Hero/HeroSlider"
import PublicProductList from "../components/Public/PublicProductList"
import MisionVision from "../components/About/MisionVision"

// Publicidad gestionada desde Supabase
import AdSlotManaged from "../components/Ads/AdSlotManaged"
import StickyPartnerBannerManaged from "../components/Ads/StickyPartnerBannerManaged"

// (Opcional) empresas destacadas gestionadas si ya creaste el componente
// import FeaturedCompaniesManaged from '../components/Companies/FeaturedCompaniesManaged';

export default function HomePage() {
  return (
    <>
      {/* Fondo general suave para que no se vea todo blanco */}
      <div className="bg-gradient-to-br from-amber-50 via-sky-50 to-indigo-50">
        <main className="max-w-7xl mx-auto px-4 py-6 space-y-10">
          {/* Cintillo de ofertas (además del de divisas en el Header) */}

          {/* HERO con slider y una capa de color */}
          <section className="rounded-3xl overflow-hidden shadow border bg-white">
            <div className="bg-gradient-to-r from-indigo-600 via-sky-600 to-indigo-600 text-white px-5 py-4">
              <h1 className="text-xl md:text-2xl font-extrabold">
                Encuentra, compara y ubica
              </h1>
              <p className="text-sm md:text-base opacity-90">
                Productos y servicios cerca de ti, con precios claros y mapa
                para llegar.
              </p>
            </div>
            <div className="p-3 md:p-4 bg-white">
              <HeroSlider />
            </div>
          </section>

          {/* Bienvenida con CTA + 3 tarjetas para “llenar” visualmente */}
          <section className="grid md:grid-cols-3 gap-4">
            <div className="md:col-span-2 rounded-3xl border shadow-sm bg-white p-5 relative overflow-hidden">
              <div
                className="absolute inset-0 opacity-10 pointer-events-none"
                style={{
                  backgroundImage: "url(/logo.png)",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center center", // Centrado
                  backgroundSize: "180px", // Tamaño ajustado
                }}
              />
              <h2 className="text-2xl font-extrabold">
                Bienvenido a QuipusMania: Tu Ecosistema de Comercio Local y
                Servicios.
              </h2>
              <p className="text-gray-700 mt-2 max-w-2xl">
                Descubre una plataforma integral donde la búsqueda y comparación
                se unen a la conveniencia. Aquí no solo encuentras una vasta
                selección de productos y servicios de calidad, sino que también
                puedes comparar precios de forma transparente y localizar
                rápidamente los comercios más cercanos a tu ubicación. Empieza a
                ahorrar tiempo y dinero hoy.
              </p>
              <div className="flex flex-wrap gap-3 mt-4">
                <a
                  href="/productos"
                  className="px-4 py-2 rounded-lg bg-indigo-600 text-white hover:bg-indigo-700"
                >
                  Ver productos
                </a>
                <a
                  href="/register"
                  className="px-4 py-2 rounded-lg border border-indigo-200 text-indigo-700 bg-indigo-50 hover:bg-indigo-100"
                >
                  Afiliar mi comercio
                </a>
              </div>
            </div>

            {/* 3 tarjetas rápidas para darle vida */}
            <div className="space-y-4">
              <div className="rounded-2xl border bg-white p-4 shadow-sm">
                <div className="text-sm text-slate-600">¡Compara!</div>
                <div className="font-semibold">
                  Ahorra tiempo y dinero con nuestro comparador de precios.
                </div>
              </div>
              <div className="rounded-2xl border bg-white p-4 shadow-sm">
                <div className="text-sm text-slate-600">¡Ubica!</div>
                <div className="font-semibold">
                  Te suministramos direcciones de forma sencilla.
                </div>
              </div>
              <div className="rounded-2xl border bg-white p-4 shadow-sm">
                <div className="text-sm text-slate-600">¡Cerca de ti!</div>
                <div className="font-semibold">
                  Filtra por Estado / Municipio / Parroquia
                </div>
              </div>
            </div>
          </section>

          {/* Zona de contenido + barra lateral */}
          <div className="grid lg:grid-cols-3 gap-6">
            {/* Columna principal */}
            <div className="lg:col-span-2 space-y-6">
              {/* Misión / Visión / Objetivos con marca de agua y color */}
              <MisionVision />
            </div>

            {/* Sidebar gestionada (anuncios) */}
            <aside className="space-y-4">
              {/* Si tienes FeaturedCompaniesManaged, colócalo aquí arriba */}
              {/* <FeaturedCompaniesManaged /> */}

              {/* Anuncios grandes (asegúrate de tener filas en la tabla ads con estos slots) */}
              <AdSlotManaged slot="sidebar-lg-1" />
              <AdSlotManaged slot="sidebar-lg-2" />
              <AdSlotManaged slot="sidebar-lg-3" />

              {/* Anuncios pequeños */}
              <div className="grid grid-cols-2 gap-3">
                <AdSlotManaged slot="sidebar-sm-1" small />
                <AdSlotManaged slot="sidebar-sm-2" small />
                <AdSlotManaged slot="sidebar-sm-3" small />
                <AdSlotManaged slot="sidebar-sm-4" small />
              </div>
            </aside>
          </div>
        </main>
      </div>

      {/* Banner pegajoso administrado (abajo) */}
      <StickyPartnerBannerManaged position="bottom" />
    </>
  )
}
